import { combineReducers } from 'redux';
import ACTIONTYPES from "../actions/ActionTypes";

export function authenticationReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.LOGIN_REQUEST:
            return { loggingIn: true, user: action.user }

        case ACTIONTYPES.LOGIN_SUCCESS:
            return { loggingIn: false, loggedIn: true, user: action.user }

        case ACTIONTYPES.LOGIN_FAILURE:
            return { loggingIn: false }

        case ACTIONTYPES.SESSIONTIMEOUT:
            return { timeout: action.timeout };

        case ACTIONTYPES.LOGOUT:
            return {}

        default:
            return state
    }
}

export function profilereducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PROFILE_INFO_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.PROFILE_INFO:
            return { profileinfo: action.profileinfo, loading: false }

        default:
            return state
    }
}


export function quicksearchreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.QUICK_SEARCH_REQUEST:
            return { ...state, isFetching: true }

        case ACTIONTYPES.QUICK_SEARCH_RECORDS:
            return { preferencelist: action.preferencelist, isFetching: false }

        default:
            return state
    }
}

export function quicksearchrootreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.QUICK_SEARCH_RECORDS_ROOT:
            return { alumnirecordsroot: action.alumnirecordsroot }

        default:
            return state
    }
}

export function isadminreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ISADMIN_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ISADMIN:
            return { ...state, loading: false, isadmin: action.isadmin, 
                isSuperAlumniAdmin: action.isSuperAlumniAdmin,
                isCSTSupport: action.isCSTSupport,
                isCouncilCommittee: action.isCouncilCommittee,
                isAlumniAdmin: action.isAlumniAdmin,
                getCSTRoleOrg: action.getCSTRoleOrg,
             }

        case ACTIONTYPES.ISSPECIALIST:
            return { ...state, loading: false, isspecialist: action.isspecialist, isadmin: false, isSuperAlumniAdmin: false,
                isCSTSupport: false,
                isCouncilCommittee: false,
                isAlumniAdmin: false
             }

        // case ACTIONTYPES.ISSUPERADMIN:
        //     return { ...state, loading: false, isSuperAlumniAdmin: action.isSuperAlumniAdmin }

        default:
            return state
    }
}

export function columnlistreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.COMPLETE_COLUMN_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.COMPLETE_COLUMN_LIST:
            return { loading: false, columnlist: action.columnlist }

        case ACTIONTYPES.COMPLETE_COLUMN_LIST_ERROR:
            return { loading: false, error: action.error }

        default:
            return state
    }
}


export function publicationreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PUBLICATIONS_LOADING:
            return { loading: true }

        case ACTIONTYPES.PUBLICATIONS:
            return { loading: false, publications: action.publications }

        default:
            return state
    }
}

export function mypreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.MY_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.MY_PREFERENCE_LIST:
            return { loading: false, preferencelist: action.preferencelist }

        default:
            return state
    }
}

export function publicpreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PUBLIC_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.PUBLIC_PREFERENCE_LIST:
            return { loading: false, preferencelist: action.preferencelist }

        default:
            return state
    }
}


export function quickpreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.QUICK_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.QUICK_PREFERENCE_LIST:
            return { loading: false, preferencelist: action.preferencelist }

        default:
            return state
    }
}

export function dashboardmypreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.DASHBOARD_MY_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.DASHBOARD_MY_PREFERENCE_LIST:
            return { loading: false, mypreferencelist: action.preferencelist }

        default:
            return state
    }
}

export function redirectdashboardreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ROLES_LOADING:
            return { loading: true }

        case ACTIONTYPES.ROLES_RECEIVED:
            return { loading: false }

        default:
            return state
    }
}

export function dashboardquickpreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.DASHBOARD_QUICK_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.DASHBOARD_QUICK_PREFERENCE_LIST:
            return { loading: false, quickpreferencelist: action.preferencelist }

        default:
            return state
    }
}

export function runpreferencelistreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.RUN_PREFERENCE_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.RUN_PREFERENCE_LIST:
            return {
                loading: false, preferencelist: action.preferencelist,
                maxRecords: action.maxRecords, TotalRecordCount: action.TotalRecordCount,
                preferenceFilter: action.filters
            }

        case ACTIONTYPES.REMOVE_QUICK_PREFERENCE_LIST:
            return { loading: false, preferencelist: undefined, }

        default:
            return state
    }
}

export function getpreferencedatareducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.GET_PREFERENCE_DATA_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_PREFERENCE_DATA:
            return { ...state, loading: false, preferencedata: action.preferencedata }

        case ACTIONTYPES.GET_PREFERENCE_DATA_FAILURE:
            return { ...state, loading: false, error: action.error }

        default:
            return state
    }
}

export function searchpendingmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.SEARCH_PENDING_MEMBERSHIP:
            return { value: action.value }

        default:
            return state
    }
}

export function chasepaymentreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.CHASE_PAYMENT_LOADING:
            return { loading: true }

        case ACTIONTYPES.CHASE_PAYMENT_INIT:
            return { loading: false, initTransaction: action.initTransaction }

        default:
            return state
    }
}

export function updateprofilereducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.UPDATE_PROFILE_LOADING:
            return { loading: true }

        case ACTIONTYPES.UPDATE_PROFILE:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function personsprofilereducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PERSONS_PROFILE_LOADING:
            return { loading: true }

        case ACTIONTYPES.PERSONS_PROFILE:
            return { loading: false, profileinfo: action.profileinfo }

        default:
            return state
    }
}

export function eventreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.GET_EVENTS_LOADING:
            return { loading: true }

        case ACTIONTYPES.GET_EVENTS:
            return { loading: false, events: action.events }

        default:
            return state
    }
}

export function ethnicitiesreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ETHNICITIES_LOADING:
            return { loading: true }

        case ACTIONTYPES.ETHNICITIES_RECEIVED:
            return { loading: false, ethnicities: action.ethnicities }

        default:
            return state
    }
}

export function occupationsreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.OCCUPATIONS_LOADING:
            return { loading: true }

        case ACTIONTYPES.OCCUPATIONS_RECEIVED:
            return { loading: false, occupations: action.occupations }

        default:
            return state
    }
}

export function giftmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION_ERROR:
            return { loading: false }

        case ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION_LOADING:
            return { loading: true }

        case ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION:
            return { loading: false, response: action.response }

        default:
            return state
    }
}

export function deniedmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.DENIED_MEMBERSHIP_LOADING:
            return { loading: true }

        case ACTIONTYPES.DENIED_MEMBERSHIP_RECEIVED:
            return { loading: false, deniedmemberships: action.deniedmemberships }

        default:
            return state
    }
}

export function pendingmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PENDING_MEMBERSHIP_LOADING:
            return { loading: true }

        case ACTIONTYPES.PENDING_MEMBERSHIP_RECEIVED:
            return { loading: false, pendingmembership: action.pendingmembership }

        default:
            return state
    }
}

export function processedmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PROCESSED_MEMBERSHIP_LOADING:
            return { loading: true }

        case ACTIONTYPES.PROCESSED_MEMBERSHIP_RECEIVED:
            return { loading: false, processedmemberships: action.processedmemberships }

        default:
            return state
    }
}

export function membershiptoactivatereducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.MEMBERSHIP_RECORD_LOADING:
            return { loading: true, error: null }

        case ACTIONTYPES.MEMBERSHIP_RECORD_RECEIVED:
            return { loading: false, record: action.record, error: null }

        case ACTIONTYPES.MEMBERSHIP_RECORD_FAILURE:
            return { loading: false, error: action.error };

        default:
            return state
    }
}

export function membershiptransactionreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.MEMBERSHIP_RECORD_PAYMENT_LOADING:
            return { loading: true }

        case ACTIONTYPES.MEMBERSHIP_RECORD_PAYMENT_RECEIVED:
            return { loading: false, record: action.record }

        default:
            return state
    }
}

export function countriesreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.COUNTRIES_LOADING:
            return { loading: true }

        case ACTIONTYPES.COUNTRIES_RECEIVED:
            return { loading: false, countries: action.countries }

        case ACTIONTYPES.COUNTRIES_FAILED:
            return { loading: false, error: true }

        default:
            return state
    }
}

export function allstatesreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.STATES_LOADING:
            return { loading: true }

        case ACTIONTYPES.STATES_RECEIVED:
            return { loading: false, states: action.states }

        case ACTIONTYPES.STATES_FAILED:
            return { loading: false, error: true }

        default:
            return state
    }
}

export function paymentcompletedreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PAYMENT_COMPLETED:
            return { status: true }

        default:
            return state
    }
}

export function nesalevelsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.NESA_LEVELS_LOADING:
            return { loading: true }

        case ACTIONTYPES.NESA_LEVELS_RECEIVED:
            return { loading: false, levels: action.levels }

        case ACTIONTYPES.NESA_LEVELS_FAILED:
            return { loading: false, error: true }

        default:
            return state
    }
}

export function saflevelsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.SAF_LEVELS_LOADING:
            return { loading: true }

        case ACTIONTYPES.SAF_LEVELS_RECEIVED:
            return { loading: false, levels: action.levels }

        default:
            return state
    }
}

export function productpricereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PRODUCT_PRICING_LOADING:
            return { loading: true }

        case ACTIONTYPES.PRODUCT_PRICING_RECEIVED:
            return { loading: false, productprice: action.productprice }
            console.log('reducer productprice', action.productprice)

        case ACTIONTYPES.PRODUCT_PRICING_FAILED:
            return { loading: false, error: true }

        default:
            return state
    }
}


export function eagleinforeducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MY_EAGLE_INFO_LOADING:
            return { loading: true }

        case ACTIONTYPES.MY_EAGLE_INFO_RECEIVED:
            return { loading: false, eagleinfo: action.eagleinfo }

        default:
            return state
    }
}


export function safmembershipreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.SAF_RESGISTRATION_LOADING:
            return { loading: true }

        case ACTIONTYPES.SAF_RESGISTRATION_ERROR:
            return { loading: false }

        case ACTIONTYPES.SAF_RESGISTRATION:
            return { loading: false, response: action.response }

        default:
            return state
    }
}

export function purchasemembershipreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PURCHASE_RESGISTRATION_LOADING:
            return { loading: true }

        case ACTIONTYPES.PURCHASE_RESGISTRATION_ERROR:
            return { loading: false }

        case ACTIONTYPES.PURCHASE_RESGISTRATION:
            return { loading: false, response: action.response }

        default:
            return state
    }
}


export function promocodereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.PROMOCODE_ERROR:
            return { loading: false, error: action.error }

        case ACTIONTYPES.PROMOCODE_APPLIED:
            return { loading: false, response: action.response.amount, promoCode: action.response.promocode }

        case ACTIONTYPES.REMOVE_PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.REMOVE_PROMOCODE_ERROR:
            return { loading: false, error: action.error }

        case ACTIONTYPES.PROMOCODE_REMOVED:
            return { loading: false, removedPromoAmount: action.response }

        default:
            return state
    }
}


export function phonecountrycodereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PHONE_COUNTRY_CODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.PHONE_COUNTRY_CODE:
            return { loading: false, code: action.code }

        case ACTIONTYPES.PHONE_COUNTRY_CODE_FAILED:
            return { loading: false, error: true }

        default:
            return state
    }
}


export function updateaddressreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.UPDATING_ADDRESS:
            return { loading: true }

        case ACTIONTYPES.ADDRESS_UPDATED:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function advancedsearchreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADVANCED_SEARCH_LIST_LOADING:
            return { loading: true }

        case ACTIONTYPES.ADVANCED_SEARCH_LIST:
            return {
                loading: false, preferencelist: action.preferencelist,
                maxRecords: action.maxRecords, TotalRecordCount: action.TotalRecordCount
            }

        case ACTIONTYPES.REMOVE_ADVANCED_SEARCH_LIST:
            return { loading: false, preferencelist: undefined, }

        default:
            return state
    }
}

export function activateMembershipreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ACTIVATE_MEMBERSHIP_STATUS_LOADING:
            return { loading: true }

        case ACTIONTYPES.ACTIVATE_MEMBERSHIP_STATUS:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function denyMembershipreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DENY_MEMBERSHIP_APPLICATION_STATUS_LOADING:
            return { loading: true }

        case ACTIONTYPES.DENY_MEMBERSHIP_APPLICATION_STATUS:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function denyToPendingMembershipreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING:
            return { loading: true }

        case ACTIONTYPES.DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function alumniinforeducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ALUMNI_INFO_LOADING:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_INFO:
            return { profileinfo: action.profileinfo, loading: false }

        default:
            return state
    }
}

export function webcontactreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.WEB_CONTACT_INFORMATION_UPDATING:
            return { ...state, loading: true }

        case ACTIONTYPES.WEB_CONTACT_INFORMATION_UPDATED:
            return { status: action.status, loading: false }

        default:
            return state
    }
}

export function alumnieagleinforeducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ALUMNI_EAGLE_INFO_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ALUMNI_EAGLE_INFO_RECEIVED:
            return { eagleinfo: action.eagleinfo, loading: false }

        default:
            return state
    }
}

export function addmembershipreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION:
            return { response: action.response, regresponse: action.regresponse, loading: false, paymentSuccess: true }

        case ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION_ERROR:
            return { error: action.error, loading: false, paymentSuccess: false }

        default:
            return state
    }
}
export function cashPaymentreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.CASH_PAYMENT_INITIATED:
            return { ...state, loading: true }

        case ACTIONTYPES.CASH_PAYMENT_COMPLETED:
            return { response: action.response, loading: false }

        case ACTIONTYPES.CASH_PAYMENT_ERROR:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function nesaregistrationreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.NESA_REGISTRATION_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.NESA_REGISTRATION_RECEIVED:
            return { reg: action.reg, loading: false }

        default:
            return state
    }
}

export function safregistrationreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.SAF_REGISTRATION_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.SAF_REGISTRATION_RECEIVED:
            return { reg: action.reg, loading: false }

        default:
            return state
    }
}

export function maritalstatusreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.MARITAL_STATUS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.MARITAL_STATUS_LOADED:
            return { status: action.status, loading: false }

        default:
            return state
    }
}

export function myranksreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.MY_RANKS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.MY_RANKS_LOADED:
            return { ranks: action.ranks, loading: false }

        default:
            return state
    }
}

export function allranksreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ALL_RANKS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ALL_RANKS_LOADED:
            return { ranks: action.ranks, loading: false }

        default:
            return state
    }
}


export function addresstypesreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ADDRESS_TYPES_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ADDRESS_TYPES_LOADED:
            return { types: action.types, loading: false }

        default:
            return state
    }
}

export function updatemyaddressreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MY_ADDRESS_UPDATING:
            return { loading: true }

        case ACTIONTYPES.MY_ADDRESS_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.MY_ADDRESS_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}


export function communcationtypesreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.COMMUNICATION_TYPES_LOADING:
            return { loading: true }

        case ACTIONTYPES.COMMUNICATION_TYPES_LOADED:
            return { loading: false, types: action.types }

        default:
            return state
    }
}

export function gendersreducers(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GENDERS_LOADING:
            return { loading: true }

        case ACTIONTYPES.GENDERS_RECEIVED:
            return { loading: false, genders: action.genders }

        default:
            return state
    }
}

export function prefixreducers(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PREFIX_LOADING:
            return { loading: true }

        case ACTIONTYPES.PREFIX_RECEIVED:
            return { loading: false, prefixes: action.prefixes }

        default:
            return state
    }
}

export function suffixreducers(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.SUFFIX_LOADING:
            return { loading: true }

        case ACTIONTYPES.SUFFIX_RECEIVED:
            return { loading: false, suffixes: action.suffixes }

        default:
            return state
    }
}


export function alumniinforamtionreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATING:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function alumniinfoupdatebyadminreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATING_BY_ADMIN:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATED_BY_ADMIN:
            return { loading: false, status: action.status }

        case ACTIONTYPES.ALUMNI_INFORMATION_UPDATE_FAILED_BY_ADMIN:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function additionalinforamtionreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADDITIONAL_INFORMATION_UPDATING:
            return { loading: true }

        case ACTIONTYPES.ADDITIONAL_INFORMATION_UPDATED:
            return { loading: false, status: action.status }

        default:
            return state
    }
}


export function homeaddressreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.HOME_ADDRESS_LOADING:
            return { loading: true }

        case ACTIONTYPES.HOME_ADDRESS_RECEIVED:
            return { loading: false, address: action.address }

        default:
            return state
    }
}


export function contactinformationreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATING:
            return { loading: true }

        case ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}


export function profilepicturereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PROFILE_PICTURE_UPDATING:
            return { loading: true }

        case ACTIONTYPES.PROFILE_PICTURE_UPDATED:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function updatemembershipnotesreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MEMBERSHIP_NOTES_UPDATING:
            return { loading: true }

        case ACTIONTYPES.MEMBERSHIP_NOTES_UPDATED:
            return { loading: false }

        default:
            return state
    }
}

export function regnotesreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.RECEIVE_NOTES:
            return { notes: action.notes }

        default:
            return state
    }
}

export function downloadAdvSearchResultsCSV(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DOWNLOADING_CSV:
            return { loading: true }

        case ACTIONTYPES.DOWNLOADED_CSV:
            return { loading: false }

        case ACTIONTYPES.DOWNLOAD_CSV_ERROR:
            return { loading: false }

        default:
            return state
    }
}
export function NESAMembershipDownloadsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DOWNLOADING_NESA_MEMBERSHIP:
            return { ...state, loading: true }

        case ACTIONTYPES.DOWNLOADED_NESA_MEMBERSHIP:
            return { ...state, loading: false }

        case ACTIONTYPES.MAXIMUM_CSVRECORDS_REACHED:
            return { ...state, loading: false, maxCSVRecords: true }

        case ACTIONTYPES.MAXIMUM_CSVRECORDS_REACHED_ClOSE:
            return { ...state, loading: false, maxCSVRecords: false }

        // case ACTIONTYPES.DOWNLOADED_NESA_PENDING_MEMBERSHIP:
        //     return { ...state, loading: false, NESApendingMembershipCSV: action.NESADownloads }

        // case ACTIONTYPES.DOWNLOADED_NESA_PROCESSED_MEMBERSHIP:
        //     return { ...state,  loading: false, NESAprocessedMembershipCSV: action.NESADownloads }

        // case ACTIONTYPES.DOWNLOADED_NESA_DENIED_MEMBERSHIP:
        //     return {  ...state, loading: false, NESAdeniedMembershipCSV: action.NESADownloads }

        default:
            return state
    }
}
export function nesamembershipupdatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.NESA_MEMBERSHIP_UPDATING:
            return { loading: true }

        case ACTIONTYPES.NESA_MEMBERSHIP_UPDATED:
            return { loading: false, updated: action.status }

        case ACTIONTYPES.NESA_MEMBERSHIP_UPDATE_FAILED:
            return { loading: false, error: action.error }


        default:
            return state
    }
}

export function nesaNonRevenueMembershipAddReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADDING:
            return { loading: true, added: false, error: null }

        case ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADDED:
            return { loading: false, added: true, response: action.response, error: null }

        case ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADD_FAILED:
            return { loading: false, added: false, error: action.error }

        default:
            return state
    }
}


export function safmembershipupdatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.SAF_MEMBERSHIP_UPDATING:
            return { loading: true }

        case ACTIONTYPES.SAF_MEMBERSHIP_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.SAF_MEMBERSHIP_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function alumniaddressupdatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ALUMNI_ADDRESS_UPDATING:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_ADDRESS_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.ALUMNI_ADDRESS_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}


export function alumniemailupdatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATING:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATED:
            return { loading: false, status: action.status }

        case ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATE_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function privacysettingsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.PRIVACY_SETTINGS_LOADING:
            return { loading: true }

        case ACTIONTYPES.PRIVACY_SETTINGS_UPDATED:
            return { loading: false }

        default:
            return state
    }
}
export function alumniPrivacyOptionsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTING_ALUMNI_PRIVACY_OPTIONS:
            return { loading: true }

        case ACTIONTYPES.RECEIVED_ALUMNI_PRIVACY_OPTIONS:
            return { loading: false, privacysettingsOptions: action.alumniSettings }

        case ACTIONTYPES.FAILED_TO_GET_ALUMNI_PRIVACY_OPTIONS:
            return { loading: false }

        default:
            return state
    }
}

export function updatePrivacysettingsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.UPDATING_ALUMNI_PRIVACY_OPTIONS:
            return { isUpdating: true }

        case ACTIONTYPES.UPDATED_ALUMNI_PRIVACY_OPTIONS:
            return { isUpdating: false }

        case ACTIONTYPES.FAILED_TO_UPDATE_ALUMNI_PRIVACY_OPTIONS:
            return { isUpdating: false }

        default:
            return state
    }
}


export function socialmedialookupreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOOKUP_SOCIALMEDIA_LOADING:
            return { loading: true }

        case ACTIONTYPES.LOOKUP_SOCIALMEDIA_RECEIVED:
            return { loading: false, socialmedialookup: action.socialmedialookup }

        default:
            return state
    }
}

export function regstatusreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTING_REG_STATUS:
            return { loading: true }

        case ACTIONTYPES.RECEIVING_REG_STATUS:
            return { loading: false, status: action.status }

        case ACTIONTYPES.REG_STATUS_FAILED:
            return { loading: false, regError: action.error };

        default:
            return state
    }
}

export function accepttocreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ACCEPTING_TOC:
            return { loading: true }

        case ACTIONTYPES.ACCEPTED_TOC:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function alumnisummaryreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_ALUMNI_SUMMARY:
            return { loading: true }

        case ACTIONTYPES.GET_ALUMNI_SUMMARY:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}

export function eagleScoutsSummaryreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_EAGLE_SCOUTS_SUMMARY:
            return { loading: true }

        case ACTIONTYPES.GET_EAGLE_SCOUTS_SUMMARY:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}

export function nesaSummaryreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_NESA_SUMMARY:
            return { loading: true }

        case ACTIONTYPES.GET_NESA_SUMMARY:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}
export function eagleScoutsSummaryCustomDatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE:
            return { loading: true }

        case ACTIONTYPES.GET_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}

export function nesaSummaryCustomDatereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_NESA_SUMMARY_CUSTOMDATE:
            return { loading: true }

        case ACTIONTYPES.GET_NESA_SUMMARY_CUSTOMDATE:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}

export function alumnisummarybtwreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.GETTING_ALUMNI_SUMMARY_BTW:
            return { loading: true }

        case ACTIONTYPES.GET_ALUMNI_SUMMARY_BTW:
            return { loading: false, summary: action.summary }

        default:
            return state
    }
}

export function getAlumniAndLocalAwardsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_ALUMNI_AND_LOCAL_AWARDS:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_ALUMNI_AND_LOCAL_AWARDS:
            return { loading: false, alumniAndLocalAwards: action.awards };

        case ACTIONTYPES.FAILED_TO_GET_ALUMNI_AND_LOCAL_AWARDS:
            return { loading: false };

        default:
            return state;
    }
}
export function getAlumniEagleRanksByUsernameReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_RANKS_BY_USERNAME:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_RANKS_BY_USERNAME:
            return { loading: false, alumniRanks: action.alumniRanks };

        case ACTIONTYPES.FAILED_TO_GET_RANKS_BY_USERNAME:
            return { loading: false };

        default:
            return state;
    }
}
export function getScoutingAffiliationsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_SCOUTINGS_AFFILIATIONS:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_SCOUTINGS_AFFILIATIONS:
            return { loading: false, scoutingAffiliations: action.scoutingAffiliations };

        case ACTIONTYPES.FAILED_TO_GET_SCOUTINGS_AFFILIATIONS:
            return { loading: false };

        default:
            return state;
    }
}
export function getCouncilAffiliationsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_COUNCIL_AFFILIATIONS:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_COUNCIL_AFFILIATIONS:
            return { loading: false, councilAffiliations: action.councilAffiliations };

        case ACTIONTYPES.FAILED_TO_GET_COUNCIL_AFFILIATIONS:
            return { loading: false };

        default:
            return state;
    }
}
export function getAffinityGropusReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_AFFINITIES:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_AFFINITIES:
            return { loading: false, affinityGroups: action.affinityGroups };

        case ACTIONTYPES.FAILED_TO_GET_AFFINITIES:
            return { loading: false };

        default:
            return state;
    }
}

export function getCouncilByZipCodeReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REQUESTED_TO_GET_COUNCIL_BY_ZIPCODE:
            return { loading: true };

        case ACTIONTYPES.RECEIVED_COUNCIL_BY_ZIPCODE:
            return { loading: false, councilByZip: action.councilByZip };

        case ACTIONTYPES.FAILED_TO_GET_COUNCIL_BY_ZIPCODE:
            return { loading: false };

        default:
            return state;
    }
}

export function awardsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_AWARDS:
            return { loading: true }

        case ACTIONTYPES.LOADED_AWARDS:
            return { loading: false, awards: action.awards }

        default:
            return state
    }
}

export function alumniawardsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_ALUMNI_AWARDS:
            return { loading: true }

        case ACTIONTYPES.LOADED_ALUMNI_AWARDS:
            return { loading: false, awards: action.awards }

        default:
            return state
    }
}

export function scoutingsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_SCOUTINGS:
            return { loading: true }

        case ACTIONTYPES.LOADED_SCOUTINGS:
            return { loading: false, scoutings: action.scoutings }

        default:
            return state
    }
}

export function affinitiesreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_AFFINITIES:
            return { loading: true }

        case ACTIONTYPES.LOADED_AFFINITIES:
            return { loading: false, affinities: action.affinities }

        default:
            return state
    }
}

export function localAwardsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_LOCALAWARDS:
            return { loading: true }

        case ACTIONTYPES.LOADED_LOCALAWARDS:
            return { loading: false, localAwards: action.localAwards }

        default:
            return state
    }
}

export function scoutingsdeletereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DELETE_SCOUTINGS:
            return { loading: true }

        case ACTIONTYPES.DELETED_SCOUTINGS:
            return { loading: false, scoutings: action.status }

        default:
            return state
    }
}

export function adminRepairReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADD_ADMINREPAIR:
            return { loading: true }

        case ACTIONTYPES.ADDED_ADMINREPAIR:
            return { loading: false, repairStatus: action.status }

        case ACTIONTYPES.ADD_ADMINREPAIR_FAILED:
            return { loading: false, error: action.error }

        default:
            return state
    }
}

export function addNewEagleRecordRepairReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADD_NEW_EAGLE_DETAILS:
            return { loading: true }

        case ACTIONTYPES.ADDED_NEW_EAGLE_DETAILS:
            return { loading: false }

        case ACTIONTYPES.FAILED_NEW_EAGLE_DETAILS:
            return { loading: false }

        default:
            return state
    }
}

export function scoutingsaddreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADD_SCOUTING:
            return { loading: true }

        case ACTIONTYPES.ADDED_SCOUTING:
            return { loading: false, scoutings: action.status }

        default:
            return state
    }
}

export function councilsaddreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.ADD_COUNCILS:
            return { loading: true }

        case ACTIONTYPES.ADDED_COUNCILS:
            return { loading: false, status: action.status }

        default:
            return state
    }
}

export function orgCouncilsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_ORGANIZATION_COUNCILS:
            return { loading: true }

        case ACTIONTYPES.LOADED_ORGANIZATION_COUNCILS:
            return { loading: false, councils: action.councils }

        default:
            return state
    }
}

export function councilsreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_COUNCILS:
            return { loading: true }

        case ACTIONTYPES.LOADED_COUNCILS:
            return { loading: false, councils: action.councils }

        default:
            return state
    }
}

export function nationalAwardsReducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.LOADING_NATIONAL_AWARDS:
            return { loading: true }

        case ACTIONTYPES.LOADED_NATIONAL_AWARDS:
            return { loading: false, nationalAwards: action.nationalAwards }

        default:
            return state
    }
}

export function councildeletereducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.DELETE_COUNCILS:
            return { loading: true }

        case ACTIONTYPES.DELETED_COUNCILS:
            return { loading: false, council: action.status }

        default:
            return state
    }
}

export function redirectingreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.REDIRECTING:
            return { loading: true }

        case ACTIONTYPES.REDIRECTED:
            return { loading: false }

        default:
            return state
    }
}

export function getmemberidreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MEMBERID_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.MEMBERID_LOADED:
            return { ...state, loading: false, memberids: action.memberids }

        case ACTIONTYPES.ADDING_MEMBERID:
            return { ...state, isAddingMID: true }

        case ACTIONTYPES.ADDED_MEMBERID:
            return { ...state, isAddingMID: false, memberids: action.memberids }

        case ACTIONTYPES.FAILED_TO_ADD_MEMBERID:
            return { ...state, isAddingMID: false }

        case ACTIONTYPES.DELETING_MEMBERID:
            return { ...state, loading: true }

        case ACTIONTYPES.DELETED_MEMBERID:
            return { ...state, loading: false, memberids: action.memberids }

        case ACTIONTYPES.FAILED_TO_DELETE_MEMBERID:
            return { ...state, loading: false }

        default:
            return state
    }
}

export function updatememberidreducer(state = {}, action) {

    switch (action.type) {
        case ACTIONTYPES.MEMBERID_UPDATING:
            return { loading: true }

        case ACTIONTYPES.MEMBERID_UPDATED:
            return { loading: false, memberids: action.memberids }

        default:
            return state
    }
}

export function getComPreferReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.LOADING_COM_PREFER:
            return { loading: true }

        case ACTIONTYPES.COM_PREFER:
            return { loading: false, communication: action.communication }

        default:
            return state
    }
}

export function eagleSearchReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.SEARCHING_EAGLE:
            return { ...state, searching: true }

        case ACTIONTYPES.SEARCHED_EAGLE:
            return { ...state, searching: false, eagle: action.eagle }

        default:
            return state
    }
}

export function changeColumnStateReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.UPDATING_COLUMN:
            return { updatingColumns: true }

        case ACTIONTYPES.UPDATED_COLUMN:
            return { updatingColumns: false }

        default:
            return state
    }
}

export function sparkOpportunityFormReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.SENDING_SPARK_OPPORTUNITY_FORM:
            return { isSendingMail: true }

        case ACTIONTYPES.SUCCESSFULLY_SENT_SPARK_OPPORTUNITY_FORM:
            return { mailSent: true }

        case ACTIONTYPES.FAILED_TO_SENT_SPARK_OPPORTUNITY_FORM:
            return { mailFailed: true }

        default:
            return state
    }
}
export function PaymentsCreateReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.PAYMENTS_CREATING:
            return { loading: true }

        case ACTIONTYPES.PAYMENTS_CREATED:
            return { loading: false, response: action.response }

        default:
            return state
    }
}

export function getOrderSourceReducer(state = {}, action) {

    switch (action.type) {

        // case ACTIONTYPES.GETTING_ORDER_SOURCE:
        //     return { loading: true }

        case ACTIONTYPES.GOT_ORDER_SOURCE_SUCCESSFULLY:
            return {
                //         loading: false,
                orderSourceLookup: action.orderSource
            }

        // case ACTIONTYPES.ORDER_SOURCE_FAILED:
        //     return { loading: false, err: action.response }

        default:
            return state
    }
}
export function getBSA_orderTypeReducer(state = {}, action) {

    switch (action.type) {

        // case ACTIONTYPES.GETTING_BSA_ORDER_TYPE:
        //     return { loading: true }

        case ACTIONTYPES.GOT_BSA_ORDER_TYPE_SUCCESSFULLY:
            return {
                // loading: false,
                BSA_OrderTypeLookup: action.BSA_OrderType
            }

        // case ACTIONTYPES.BSA_ORDER_TYPE_FAILED:
        //     return { loading: false, err: action.response }

        default:
            return state
    }
}

export function getPromoCodeReducer(state = { searching: false, loading: false, promoCodes: [] }, action) {

    switch (action.type) {

        case ACTIONTYPES.SEARCH_PROMOCODE_LOADING:
            return { searching: true, loading: false }

        case ACTIONTYPES.GET_PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.GOT_PROMOCODE_SUCCESSFULLY:
            return { loading: false, searching: false, promoCodes: action.promoCodes }

        case ACTIONTYPES.GET_PROMOCODE_ERROR:
            return { loading: false, searching: false, err: action.response }

        default:
            return state
    }
}
export function addPromoCodeReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ADD_PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.ADDED_PROMOCODE_SUCCESSFULLY:
            return { loading: false, response: action.message }

        case ACTIONTYPES.ADD_PROMOCODE_ERROR:
            return { loading: false, err: action.err }

        default:
            return state
    }
}

export function updatePromoCodeReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.UPDATE_PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.UPDATED_PROMOCODE_SUCCESSFULLY:
            return { loading: false, response: action.response }

        case ACTIONTYPES.UPDATE_PROMOCODE_ERROR:
            return { loading: false, err: action.err }

        default:
            return state
    }
}

export function deletePromoCodeReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.DELETE_PROMOCODE_LOADING:
            return { loading: true }

        case ACTIONTYPES.DELETED_PROMOCODE_SUCCESSFULLY:
            return { loading: false, response: true }

        case ACTIONTYPES.DELETE_PROMOCODE_ERROR:
            return { loading: false, err: action.err }

        default:
            return state
    }
}

export function shoppingCartReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.GETTING_SHOPPINGCART:
            return { loading: true }

        case ACTIONTYPES.RECIVED_SHOPPINGCART:
            return { loading: false, response: action.response }

        default:
            return state
    }
}

export function bulkuploadreducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.BULK_UPLOADING:
            return { loading: true }

        case ACTIONTYPES.BULK_UPLOADED:
            return { loading: false, response: action.res }

        default:
            return state
    }
}
export function expiryMembershipReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.REQ_TO_EXPIRE_MEMBERSHIP:
            return { loading: true }

        case ACTIONTYPES.RES_OF_EXPIRE_MEMBERSHIP:
            return { loading: false }

        default:
            return state
    }
}

export function alumnibulkuploadreducer(state = { loading: false, response: [] }, action) {

    switch (action.type) {

        case ACTIONTYPES.ALUMNI_BULK_UPLOADING:
            return { loading: true }

        case ACTIONTYPES.ALUMNI_BULK_UPLOADED:
            return { loading: false, response: action.res }

        case ACTIONTYPES.ALUMNI_BULK_UPLOAD_ERROR:
            return { loading: false, response: [] }

        default:
            return state
    }
}

export function hobbiesAndBusinessReducer(state = {
    hobbiesUpdating: false,
    businessUpdating: false,
    employerUpdating: false
}, action) {

    switch (action.type) {

        case ACTIONTYPES.ADDING_OR_REMOVING_HOBBIES:
            return { hobbiesUpdating: true }

        case ACTIONTYPES.HOBBIES_ADDED_OR_REMOVED_SUCCESSFULLY:
            return { hobbiesUpdating: false, }

        case ACTIONTYPES.ADDING_OR_REMOVING_BUSINESS:
            return { businessUpdating: true }

        case ACTIONTYPES.BUSINESS_ADDED_OR_REMOVED_SUCESSFULLY:
            return { businessUpdating: false }

        case ACTIONTYPES.UPDATING_EMPLOYER_DETAILS:
            return { employerUpdating: true }

        case ACTIONTYPES.UPDATED_EMPLOYER_DETAILS:
            return { employerUpdating: false }

        case ACTIONTYPES.DELETING_EMPLOYER_DETAILS:
            return { employerUpdating: true }

        case ACTIONTYPES.DELETED_EMPLOYER_DETAILS:
            return { employerUpdating: false }

        default:
            return state
    }
}

export function eagleNesaMembershipsReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_RECEIVED:
            return { ...state, loading: false, memberships: action.memberIds };

        case ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_ERROR:
            return { loading: false, error: action.error }

        default:
            return state;
    }
}

export function assignRolesPositionsReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.ASSIGN_ROLES_POSITIONS_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.ASSIGN_ROLES_POSITIONS:
            return { ...state, loading: false, positionList: action.positionList };

        case ACTIONTYPES.ASSIGN_ROLES_POSITIONS_ERROR:
            return { ...state, loading: false, error: action.error }

        default:
            return state;
    }
}

export function userFunctionalRolesReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.USER_FUNCTIONAL_ROLES_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.USER_FUNCTIONAL_ROLES_RECEIVED:
            return { ...state, loading: false, roleData: action.roleData };

        case ACTIONTYPES.USER_FUNCTIONAL_ROLES_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export function removeUserRoleReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.REMOVE_USER_ROLE_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.REMOVE_USER_ROLE_SUCCESS:
            return { ...state, loading: false, roleRemoveData: action.roleRemoveData };

        case ACTIONTYPES.REMOVE_USER_ROLE_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export function eagleGlobalReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.SEARCHING_GLOBAL:
            return { searching: true }

        case ACTIONTYPES.SEARCHED_GLOBAL:
            return { searching: false, eagle: action.eagle }

        case ACTIONTYPES.SEARCHED_GLOBAL_ERROR:
            return { ...state, searching: false, error: action.error };

        default:
            return state
    }
}

export function assignRolesPersonGuidReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.ROLES_PERSONSGUID_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.ROLES_PERSONSGUID_RECEIVE:
            return { ...state, loading: false, userInfo: action.userInfo }

        case ACTIONTYPES.ROLES_PERSONSGUID_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function activeRegistrationsReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.GETTING_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE:
            return { ...state, loading: true }

        case ACTIONTYPES.RECEIVED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE:
            return { ...state, loading: false, activeRegistrations: action.activeRegistrations }

        case ACTIONTYPES.FAILED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function childOrganzationReducer(state = {}, action) {

    switch (action.type) {

        case ACTIONTYPES.CHILD_ORG_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.CHILD_ORG_RECEIVE:
            return { ...state, loading: false, orgInfo: action.orgInfo }

        case ACTIONTYPES.CHILD_ORG_ERROR:
            return { ...state, loading: false, error: action.error };

            default:
                return state
        }
    }
    
export function GetCouncilsReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_COUNCILS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_COUNCILS_RECEIVE:
            return { ...state, loading: false, GetAllCouncils: action.GetAllCouncils }

        case ACTIONTYPES.GET_COUNCILS_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function GetPositionsReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_POSITIONS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_POSTIONS_RECEIVE:
            return { ...state, loading: false, postionsinfo: action.postionsinfo }

        case ACTIONTYPES.GET_POSTIONS_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function GetSuperAdminReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.SUPER_ADMIN_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.SUPER_ADMIN_RECEIVE:
            return { ...state, loading: false, superadmininfo: action.superadmininfo }

        default:
            return state
    }
}

export function organizationPositionsReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.ORGANIZATION_POSITIONS_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.ORGANIZATION_POSITIONS_RECEIVE:
            return { ...state, loading: false, personPositionList: action.personPositionList };

        case ACTIONTYPES.ORGANIZATION_POSITIONS_ERROR:
            return { ...state, loading: false, error: action.error }

        default:
            return state;
    }
}

export function expireRoleReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.ROLES_EXPIRE_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.ROLES_EXPIRE_SUCCESS:
            return { ...state, loading: false, expireRemoveData: action.expireRemoveData };

        case ACTIONTYPES.ROLES_EXPIRE_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

const advancedSearchInitialState = { loading: false };
const quickSearchinitialState = { loading: false };
const alumniSearchinitialState = { loading: false }

export function advancedRecordsLoaderReducer(state = advancedSearchInitialState, action) {
    switch (action.type) {
        case ACTIONTYPES.ADVANCED_RECORDS_LOADING_START:
            return { loading: true };

        case ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP:
            return { loading: false };

        default:
            return state;
    }
}

export function alumniRecordsLoaderReducer(state = quickSearchinitialState, action) {
    switch (action.type) {
        case ACTIONTYPES.ALUMNI_RECORDS_LOADING_START:
            return { loading: true };

        case ACTIONTYPES.ALUMNI_RECORDS_LOADING_STOP:
            return { loading: false };

        default:
            return state;
    }
}

export function quickRecordsLoaderReducer(state = alumniSearchinitialState, action) {
    switch (action.type) {
        case ACTIONTYPES.QUICK_RECORDS_LOADING_START:
            return { loading: true };

        case ACTIONTYPES.QUICK_RECORDS_LOADING_STOP:
            return { loading: false };

        default:
            return state;
    }
}

export function aboutToExpirePopupReducer(state = alumniSearchinitialState, action) {
    switch (action.type) {
        case ACTIONTYPES.SHOW_ABOUT_TO_EXPIRE:
            return { aboutToExpirePopup: action.aboutToExpirePopup};

        case ACTIONTYPES.HIDE_ABOUT_TO_EXPIRE:
            return { aboutToExpirePopup: {
                daysRemains: undefined,
                doesShow: false,
                role: undefined
            }
        };

        default:
            return state;
    }
}

export function GetRanksReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_RANKS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_RANKS_RECEIVE:
            return { ...state, loading: false, GetAllRanks: action.GetAllRanks }

        case ACTIONTYPES.GET_RANKS_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function UpdateRankReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.UPDATE_RANK_LOADING:
            return { ...state, loading: true };

        case ACTIONTYPES.UPDATE_RANK_SUCCESS:
            return { ...state, loading: false, updatedRank: action.payload };

        case ACTIONTYPES.UPDATE_RANK_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export function deleteRankReducer (state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.DELETE_RANK_LOADING:
            return { ...state, loading: true, error: null };

        case ACTIONTYPES.DELETE_RANK_SUCCESS:
            return { ...state, loading: false, error: null };

        case ACTIONTYPES.DELETE_RANK_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export function GetLookupsRanksReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_LOOKUPS_RANKS_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_LOOKUPS__RANKS_RECEIVE:
            return { ...state, loading: false, GetAllLookupsRanks: action.GetAllLookupsRanks }

        case ACTIONTYPES.GET_LOOKUPS_RANKS_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function addPersonReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.ADD_PERSON_REQUEST:
            return { ...state, loading: true }

        case ACTIONTYPES.ADD_PERSON_SUCCESS:
            return { ...state, loading: false, personData: action.personData }

        case ACTIONTYPES.ADD_PERSON_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

export function communityOrgTypesReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_COMMUNITY_LOADING:
            return { ...state, loading: true }

        case ACTIONTYPES.GET_COMMUNITY_RECEIVE:
            return { ...state, loading: false, categories: action.categories }

        case ACTIONTYPES.GET_COMMUNITY_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state
    }
}

const lookupInitialState = {
    lookupList: [],
    loading: false,
    error: null
};

export function communityLookupReducer(state = lookupInitialState, action) {
    switch (action.type) {

        case ACTIONTYPES.GET_COMMUNITY_LOOKUP_LOADING:
            return { ...state, loading: true, error: null };

        case ACTIONTYPES.GET_COMMUNITY_LOOKUP_SUCCESS:
            return { ...state, loading: false, lookupList: action.payload };

        case ACTIONTYPES.GET_COMMUNITY_LOOKUP_ERROR:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

// Cached alumni lookups (scoutingAssociations, affinityGroups), keyed by lookup name.
export function alumniLookupsReducer(state = {}, action) {
    switch (action.type) {
        case ACTIONTYPES.ALUMNI_LOOKUP_LOADING:
            return { ...state, [action.key]: { ...state[action.key], loading: true, error: false } };

        case ACTIONTYPES.ALUMNI_LOOKUP_SUCCESS:
            return { ...state, [action.key]: { loading: false, error: false, list: action.payload } };

        case ACTIONTYPES.ALUMNI_LOOKUP_ERROR:
            return { ...state, [action.key]: { loading: false, error: true } };

        default:
            return state;
    }
}

export function getNewReportColumnReducer(state = {}, action) {
    switch (action.type) {

        case ACTIONTYPES.COMPLETE_COLUMN_LIST_LOADING:
            return { ...state, loading: true }
            
        case ACTIONTYPES.COMPLETE_COLUMN_LIST:
                return { ...state, loading: false, getColumn: action.getColumn }
                
        case ACTIONTYPES.COMPLETE_COLUMN_LIST_ERROR:
                return { ...state, loading: false, error: action.error };
                
        default:
            return state
    }
}

const appReducer = combineReducers({
    GetSuperAdminReducer, GetPositionsReducer, GetCouncilsReducer, alumnibulkuploadreducer, bulkuploadreducer, PaymentsCreateReducer, deniedmembershipreducer, eagleSearchReducer, processedmembershipreducer, getComPreferReducer, updatememberidreducer, getmemberidreducer, redirectingreducer, councildeletereducer, councilsaddreducer, councilsreducer, nationalAwardsReducer, scoutingsaddreducer, scoutingsdeletereducer, alumniawardsreducer, scoutingsreducer, affinitiesreducer, awardsreducer, alumnisummarybtwreducer, alumnisummaryreducer, accepttocreducer, webcontactreducer, regstatusreducer, socialmedialookupreducer, authenticationReducer, maritalstatusreducer, allranksreducer, searchpendingmembershipreducer, profilereducer, quicksearchreducer, quicksearchrootreducer, isadminreducer, publicationreducer, columnlistreducer, activateMembershipreducer, safmembershipreducer, alumniinforeducer, adminRepairReducer, nesaregistrationreducer,
    mypreferencelistreducer, publicpreferencelistreducer, dashboardmypreferencelistreducer, dashboardquickpreferencelistreducer, quickpreferencelistreducer, runpreferencelistreducer, advancedsearchreducer, purchasemembershipreducer, addmembershipreducer, safregistrationreducer, alumniaddressupdatereducer,
    getpreferencedatareducer, chasepaymentreducer, updateprofilereducer, personsprofilereducer, eventreducer, redirectdashboardreducer, ethnicitiesreducer, updateaddressreducer, giftmembershipreducer, phonecountrycodereducer, alumnieagleinforeducer, myranksreducer, addresstypesreducer, alumniemailupdatereducer,
    occupationsreducer, pendingmembershipreducer, membershiptoactivatereducer, countriesreducer, allstatesreducer, paymentcompletedreducer, nesalevelsreducer, productpricereducer, eagleinforeducer, saflevelsreducer, membershiptransactionreducer, updatemyaddressreducer, updatemembershipnotesreducer, privacysettingsreducer,
    communcationtypesreducer, gendersreducers, suffixreducers, prefixreducers, alumniinforamtionreducer, additionalinforamtionreducer, homeaddressreducer, contactinformationreducer, profilepicturereducer, regnotesreducer, nesamembershipupdatereducer, safmembershipupdatereducer, alumniinfoupdatebyadminreducer, nesaNonRevenueMembershipAddReducer,
    sparkOpportunityFormReducer, localAwardsReducer, orgCouncilsReducer,
    NESAMembershipDownloadsreducer, promocodereducer,
    changeColumnStateReducer,
    eagleScoutsSummaryreducer, nesaSummaryreducer, eagleScoutsSummaryCustomDatereducer, nesaSummaryCustomDatereducer,
    getPromoCodeReducer, addPromoCodeReducer, updatePromoCodeReducer, deletePromoCodeReducer,
    getOrderSourceReducer, getBSA_orderTypeReducer,
    denyMembershipreducer,
    shoppingCartReducer,
    denyToPendingMembershipreducer, cashPaymentreducer, expiryMembershipReducer, alumniPrivacyOptionsreducer, updatePrivacysettingsreducer, getAlumniAndLocalAwardsReducer, getScoutingAffiliationsReducer, getCouncilAffiliationsReducer, getAffinityGropusReducer,
    hobbiesAndBusinessReducer, eagleNesaMembershipsReducer, assignRolesPositionsReducer, userFunctionalRolesReducer, removeUserRoleReducer, eagleGlobalReducer, assignRolesPersonGuidReducer,
    addNewEagleRecordRepairReducer,
    childOrganzationReducer, organizationPositionsReducer, expireRoleReducer, getCouncilByZipCodeReducer, advancedRecordsLoaderReducer, alumniRecordsLoaderReducer, quickRecordsLoaderReducer, aboutToExpirePopupReducer, GetRanksReducer, UpdateRankReducer,
    GetLookupsRanksReducer, activeRegistrationsReducer, addPersonReducer, communityOrgTypesReducer,
    getAlumniEagleRanksByUsernameReducer, getNewReportColumnReducer, communityLookupReducer, alumniLookupsReducer,
    downloadAdvSearchResultsCSV
})


const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js